module.exports = __webpack_public_path__ + "static/media/shrimtempura.beedafaf.jpg";